import { useCallback, useState } from "react";

// ---------------------------------------------------------------------------
// Eine Auswahl, die den Reload ueberlebt (localStorage).
// ---------------------------------------------------------------------------
// WB-6: der Umschalter Liste/Kacheln der Werkbank. Wer die Liste will, will
// sie morgen wieder — ihn bei jedem Laden zurueck auf die Kacheln zu stellen
// waere eine taegliche kleine Zumutung.
//
// `erlaubt` ist Pflicht und wird beim Lesen geprueft: im localStorage steht
// beliebiger Text (alter Wert, fremder Tab, von Hand editiert), und ein
// ungeprueftes `as T` wuerde daraus einen Zustand machen, den die Komponente
// nicht kennt.
//
// Ein gesperrter Speicher (Privatmodus, iOS-Sonderfaelle) ist kein Fehler:
// dann gilt die Wahl nur fuer diese Sitzung. Das ist der einzige Grund fuer
// die beiden `catch`-Bloecke — nichts wird verschluckt, was jemand behandeln
// koennte (Prinzip 3).

export function usePersistedChoice<T extends string>(
  key: string,
  erlaubt: readonly T[],
  fallback: T,
): readonly [T, (wert: T) => void] {
  const [wert, setWert] = useState<T>(() => {
    try {
      const roh = window.localStorage.getItem(key);
      return erlaubt.find((k) => k === roh) ?? fallback;
    } catch {
      return fallback;
    }
  });

  const setzen = useCallback(
    (neu: T) => {
      setWert(neu);
      try {
        window.localStorage.setItem(key, neu);
      } catch {
        // Speicher gesperrt — die Wahl gilt fuer diese Sitzung.
      }
    },
    [key],
  );

  return [wert, setzen] as const;
}
